import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './style.sass';
import { getPartner, getCid } from '../utils/navigation';
import InsuletIdleTimer from './InsuletIdleTimer/InsuletIdleTimer';
import { wizardSteps } from '../utils/enrollmentWizardConfig';

const EnrollmentWizard = (props) => {
  const { currentStep, hide } = props;
  const classes = classnames({
    EnrollmentWizard: true, hidden: hide,
  });

  if (!currentStep) {
    return null;
  }

  const partner = getPartner();
  const cid = getCid();
  const CurrentStep = Object.values(wizardSteps).find(el =>
    el.name === currentStep).container;

  return (
    <div className={classes} >
      <CurrentStep />
      {partner === 'op5' && cid && (<InsuletIdleTimer />)}
    </div>
  );
};

EnrollmentWizard.propTypes = {
  hide: PropTypes.bool,
  currentStep: PropTypes.string,
};

EnrollmentWizard.defaultProps = {
  hide: false,
  currentStep: undefined,
};

export default EnrollmentWizard;
